import { getApplicationSettings } from 'owa-application-settings';
import { isAccountSourceListStoreInitialized } from 'owa-account-source-list-store';

export function isOfflineSearchIndexingEnabled(): boolean {
    // The message body Dexie hooks can call this before the account source list is synced
    // to the worker, so avoid reading application settings before the account is initialized.
    if (!isAccountSourceListStoreInitialized()) {
        return false;
    }

    // Disable offline search indexing for devices with 4 or fewer cores
    const hardwareConcurrency = self.navigator?.hardwareConcurrency;
    const hasMoreThanFourCoresOrUnknown =
        typeof hardwareConcurrency !== 'number' || hardwareConcurrency > 4;
    return getApplicationSettings('PlatformType').isMonarch && hasMoreThanFourCoresOrUnknown;
}
